import { render, staticRenderFns } from "./NoHeaderLayout.vue?vue&type=template&id=bd59551e"
import script from "./NoHeaderLayout.vue?vue&type=script&lang=js"
export * from "./NoHeaderLayout.vue?vue&type=script&lang=js"
import style0 from "./NoHeaderLayout.vue?vue&type=style&index=0&id=bd59551e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports